import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  PassThroughAdapterdbgnfuhbpbsv as PassThroughAdapter,
  get_AnyAdapterx2g0krnqn0y9 as get_AnyAdapter,
  get_FloatAdapter8hkphxq3v57l as get_FloatAdapter,
  get_LongAdapter1acs38m0a7icu as get_LongAdapter,
  get_DoubleAdapter3vjvxl0ttbawu as get_DoubleAdapter,
  get_IntAdapter2kzerdn7hhunh as get_IntAdapter,
  get_BooleanAdapterefxw889yjdy4 as get_BooleanAdapter,
  get_StringAdapter1plpsgiy8rwhj as get_StringAdapter,
  get_UploadAdapter1jp2f4wtvjtde as get_UploadAdapter,
} from './Adapters.mjs';
import { listOf1jh22dvmctj1r as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from './Adapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  get250w32d89zql9 as get,
  fold2eqrvrnjdby59 as fold,
  minusKeyaa3vrrv8zn1t as minusKey,
  plus3bjhh80fy28if as plus,
  Elementfqwhwe88j543 as Element,
} from './ExecutionContext.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var KeyClass;
function Key() {
  if (KeyClass === VOID) {
    class $ {
      constructor() {
        Key_instance = this;
        this.x45_1 = (new (Builder())()).n37();
        this.y45_1 = (new (Builder())()).e46(true).n37();
      }
    }
    initMetadataForObject($, 'Key');
    KeyClass = $;
  }
  return KeyClass;
}
var Key_instance;
function Key_getInstance() {
  if (Key_instance === VOID)
    new (Key())();
  return Key_instance;
}
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp.z45_1 = LinkedHashMap().gc();
        this.a46_1 = false;
        this.b46_1 = null;
        this.c46_1 = null;
        this.d46_1 = null;
      }
      f46(falseVariables) {
        // Inline function 'kotlin.apply' call
        this.b46_1 = falseVariables;
        return this;
      }
      g46(deferredFragmentIdentifiers) {
        // Inline function 'kotlin.apply' call
        this.c46_1 = deferredFragmentIdentifiers;
        return this;
      }
      h44(errors) {
        // Inline function 'kotlin.apply' call
        this.d46_1 = errors;
        return this;
      }
      h46(customScalarAdapters) {
        // Inline function 'kotlin.apply' call
        this.z45_1.e5(customScalarAdapters.m46_1);
        return this;
      }
      e46(unsafe) {
        // Inline function 'kotlin.apply' call
        this.a46_1 = unsafe;
        return this;
      }
      f5() {
        this.z45_1.f5();
      }
      n37() {
        return new (CustomScalarAdapters())(this.z45_1, this.b46_1, this.c46_1, this.d46_1, this.a46_1);
      }
    }
    initMetadataForClass($, 'Builder', Builder);
    BuilderClass = $;
  }
  return BuilderClass;
}
var CustomScalarAdaptersClass;
function CustomScalarAdapters() {
  if (CustomScalarAdaptersClass === VOID) {
    class $ {
      constructor(customScalarAdapters, falseVariables, deferredFragmentIdentifiers, errors, unsafe) {
        Key_getInstance();
        this.i46_1 = falseVariables;
        this.j46_1 = deferredFragmentIdentifiers;
        this.k46_1 = errors;
        this.l46_1 = unsafe;
        this.m46_1 = customScalarAdapters;
      }
      n46(customScalar) {
        var tmp;
        if (!(this.m46_1.z4(customScalar.u45_1) == null)) {
          tmp = this.m46_1.z4(customScalar.u45_1);
        } else if (customScalar.t45_1 === 'com.apollographql.apollo.api.Upload') {
          tmp = get_UploadAdapter();
        } else if (listOf(['kotlin.String', 'java.lang.String']).y2(customScalar.t45_1)) {
          tmp = get_StringAdapter();
        } else if (listOf(['kotlin.Boolean', 'java.lang.Boolean']).y2(customScalar.t45_1)) {
          tmp = get_BooleanAdapter();
        } else if (listOf(['kotlin.Int', 'java.lang.Int']).y2(customScalar.t45_1)) {
          tmp = get_IntAdapter();
        } else if (listOf(['kotlin.Double', 'java.lang.Double']).y2(customScalar.t45_1)) {
          tmp = get_DoubleAdapter();
        } else if (listOf(['kotlin.Long', 'java.lang.Long']).y2(customScalar.t45_1)) {
          tmp = get_LongAdapter();
        } else if (listOf(['kotlin.Float', 'java.lang.Float']).y2(customScalar.t45_1)) {
          tmp = get_FloatAdapter();
        } else if (listOf(['kotlin.Any', 'java.lang.Object']).y2(customScalar.t45_1)) {
          tmp = get_AnyAdapter();
        } else if (this.l46_1) {
          tmp = new (PassThroughAdapter())();
        } else {
          var message = "Can't map GraphQL type: `" + customScalar.u45_1 + '` to: `' + customScalar.t45_1 + '`. Did you forget to add a scalar Adapter?';
          throw IllegalStateException().o(toString(message));
        }
        var tmp_0 = tmp;
        return (!(tmp_0 == null) ? isInterface(tmp_0, Adapter()) : false) ? tmp_0 : THROW_CCE();
      }
      r3() {
        return Key_getInstance();
      }
      s43() {
        return (new (Builder())()).h46(this).f46(this.i46_1).g46(this.j46_1);
      }
    }
    protoOf($).o46 = get;
    protoOf($).p46 = fold;
    protoOf($).q46 = minusKey;
    protoOf($).f44 = plus;
    initMetadataForClass($, 'CustomScalarAdapters', VOID, VOID, [Element()]);
    CustomScalarAdaptersClass = $;
  }
  return CustomScalarAdaptersClass;
}
//region block: exports
export {
  Builder as Builder4ra56zvvku0a,
  Key_getInstance as Key_getInstance30q5r2nw695ls,
};
//endregion

//# sourceMappingURL=CustomScalarAdapters.mjs.map
